import { render, staticRenderFns } from "./AppDepartmentListBlock.vue?vue&type=template&id=05a381aa&scoped=true"
import script from "./AppDepartmentListBlock.vue?vue&type=script&lang=js"
export * from "./AppDepartmentListBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a381aa",
  null
  
)

export default component.exports